export const ButtonTextStyle = {
  width: '55vw',
  minWidth: 'fit-content',
  fontSize: '1rem',
  padding: '7px',
  boxShadow: 'none',

  color: '#000',
  backgroundColor: '#fff',
  borderRadius: '8px',

  '&:hover': {
    color: '#000',
    backgroundColor: '#fff',
  },
  '&:disabled': {
    color: '#000',
    backgroundColor: '#fff',
    opacity: 0.5,
  },
};

export const IconButtonStyle = {
  background: 'white',
  borderRadius: '4px',
  p: '3px',
  color: '#989898',
  '&:hover': {
    opacity: '0.8',
    background: 'white',
  },
};
